export const numDayOfWeekInMonth = (day: number) => Math.ceil(day / 7);
